<template>
  <div class="signin-main">
    <div class="signin-container">
      <div class="signin-hold">
        <h1 v-html="urlmsg" class="green-text"></h1>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "GENAME",
  data() {
    return {
      urlmsg: "Please wait until we redirect !",
    };
  },
  created() {
    this.redirectif();
  },
  methods: {
    redirectif() {
      const random = this.$route.query.i;
      const apiUrl = `${process.env.VUE_APP_BASEURL}/tenantsubscription/Shareurl/${random}`;

      axios
        .get(apiUrl)
        .then((response) => {
          const portal_url = response.data;
          if (portal_url.includes("amazonaws.com")) {
            this.Checkurl(portal_url);
          } else {
            window.location.replace(portal_url);
          }
        })
        .catch((error) => {
          this.urlmsg = "Could not find the URL to redirect.";
          console.error("Error fetching URL:", error);
        });
    },
    Checkurl(portal_url) {
      debugger;
      axios
        // .head(portal_url)
        .get(portal_url)
        .then((res) => {
          if (res.status === 200) {
            // If the response is OK, fetch the actual redirect URL
            window.location.replace(portal_url);
          } else {
            this.urlmsg =
              "<span style='color:red'>The link has expired or is invalid.<span>";
          }
        })
        .catch((error) => {
          // Handle errors, including expired links
          this.urlmsg =
            "<span style='color:red'>The link has expired or is invalid.<span>";
          console.error("Error checking URL:", error);
        });
    },
  },
};
</script>

<style type="text/css">
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
html,
body {
  font-family: "Poppins", sans-serif !important;
  margin: 0;
  padding: 0;
  width: 100%;
}
html {
  font-size: 14px;
  height: 100%;
}
body {
  font-size: 14px;
  line-height: 1.42857143;
  color: #000000;
  height: 100%;
}
.signin-main {
  width: 100%;
  height: 100%;
  display: table;
  min-height: 100%;
}
.signin-container {
  display: flex;
  text-align: center;
  vertical-align: middle;
  min-height: calc(100vh - 116px);
}
.signin-hold {
  margin: auto;
  padding: 20px;
  display: inline-block;
  width: 100%;
  border-radius: 5px;
}
.green-text {
  color: #0048d8;
  margin-top: 30px;
  margin-bottom: 15px;
  font-size: 42px;
}
</style>
